import { ACTIONS } from '../Actions/rightDrawerActions';

const initialState = {
  enable: false,
  element: null,
  title: 'Drawer Title',
  secondTitle: 'Second Title',
  menuOptions: null,
  cleaner: null,
  disableEnforceFocus: false,
};

const rightDrawerReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.ENABLE:
      return {
        ...state,
        ...action.payload,
      };
    case ACTIONS.DISABLE:
      return {
        ...state,
        ...action.payload,
      };
    case ACTIONS.SET_ENFORCE_FOCUS:
      return {
        ...state,
        disableEnforceFocus: !action.payload.enforceFocus,
      };
    default:
      return state;
  }
};

export default rightDrawerReducer;
